import { defineMessages } from 'react-intl';

export default defineMessages({
  performanceTitle: {
    id: 'sku-reports.items.flyout-performance-title',
    defaultMessage: 'Performance (last 7 days)',
  },
  unitsSold: {
    id: 'sku-reports.items.flyout-units-sold',
    defaultMessage: 'Units sold',
  },
  ordersCount: {
    id: 'sku-reports.items.flyout-orders-count',
    defaultMessage: 'Number of orders',
  },
  avgEarningsPerOrder: {
    id: 'sku-reports.items.flyout-avg-earnings-per-order',
    defaultMessage: 'Avg earnings per order',
  },
  totalEarnings: {
    id: 'sku-reports.items.flyout-total-earnings',
    defaultMessage: 'Total earnings',
  },
  errorTitle: {
    id: 'sku-reports.items.flyout-error-title',
    defaultMessage: "We couldn't load this item",
  },
});
